import React from 'react';
import tpl from '../templates/list.jsx';
import BaseNewCardView from './BaseNewCardView.js';
import {canUseDOM} from '../../../helpers/canUseDOM.js';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            cardType: '',
            isMobile: canUseDOM ? window.innerWidth <= 1120 : false,
            isSegmentedCollapsed: canUseDOM ? window.innerWidth <= 900 : false,
            tab: 'all'
        };
        return this;
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({
            isMobile: window.innerWidth <= 1120,
            isSegmentedCollapsed: window.innerWidth <= 900
        });
    };

    toggleModal(type) {
        super.toggleModal();
        this.setState({
            cardType: typeof type === 'string' ? type : ''
        });
    }

    static displayName = 'CardsList';
}
